<p-table [value]="allShippingMethods" dataKey="id" [expandedRowKeys]="expandedRowsClass">
  <ng-template pTemplate="header">
    <tr>
      <th style="max-width: 3rem"></th>
      <th>Name</th>
      <th>Is Active</th>
      <th>Is Api Configured</th>
      <th>Is Default</th>
      <th>Action</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-product let-expanded="expanded">
    <tr class="parentRow">
      <td class="action">
        <button type="button" [pRowToggler]="product" pButton pRipple
          class="p-button-text p-button-rounded p-button-plain"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          *ngIf="product.childShippingMethod.length > 0" style="width: 20px;height: 20px;"></button>
      </td>
      <td>{{product.name}}</td>
      <td>{{product.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.No}}</td>
      <td>{{product.isAPIConfigured ? answertypeConstants.Yes : answertypeConstants.No}}</td>
      <td>
        <p-radioButton [disabled]="product.statusId==statusConstants.INACTIVE" [value]="true" [(ngModel)]="product.isDefault"
          (onClick)="shippingMethodDefault(product,shippingMethodConstants.parentType)"></p-radioButton>
        {{product.isDefault?answertypeConstants.Yes: answertypeConstants.No}}
      </td>
      <td class="action">
        <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top" (click)="showEditShippingMethod(product,shippingMethodConstants.parentType)">
          <i class="pi pi-pencil"></i></span>
        <span class="btnBars p-mr-0" pTooltip="Delete" (click)="checkDeleteStatus(product,shippingMethodConstants.parentType)" tooltipPosition="top"
          *ngIf="!product.isDefault"><i class="pi pi-trash"></i></span>
        <span class="btnBars p-mr-0" pTooltip="Add" (click)="showUpsServiceSelectionDialog(product)" tooltipPosition="top"
          *ngIf="product?.name?.toLowerCase() == 'ups' || product?.name?.toLowerCase() == 'fedex'"><i class="pi pi-plus"></i></span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-product>
    <ng-container *ngFor="let child of product.childShippingMethod">
      <tr>
        <td></td>
        <td style="padding-left: 2rem !important;">{{child.name}}</td>
        <td>{{child.statusId==statusConstants.ACTIVE?answertypeConstants.Yes: answertypeConstants.No}}</td>
        <td></td>
        <td>
          <p-radioButton [disabled]="child.statusId==statusConstants.INACTIVE || !product.isDefault" [value]="true"
            [(ngModel)]="child.isDefault" (onClick)="shippingMethodDefault(product,shippingMethodConstants.childType,child)"></p-radioButton>
          {{child.isDefault?answertypeConstants.Yes: answertypeConstants.No}}
        </td>
        <td class="action">
          <span class="btnBars p-mr-0" (click)="showEditShippingMethod(child,shippingMethodConstants.childType)" pTooltip="Edit"
            tooltipPosition="top"><i class="pi pi-pencil"></i></span>
          <span class="btnBars p-mr-0" (click)="checkDeleteStatus(product,shippingMethodConstants.childType,child)" pTooltip="Delete" tooltipPosition="top"
            *ngIf="!child.isDefault"><i class="pi pi-trash"></i></span>
        </td>
      </tr>
    </ng-container>
  </ng-template>
</p-table>

<p-dialog header="{{addEditShippingMethodHeader}}" [(visible)]="displayShippingMethodAdd" [modal]="true"
  [responsive]="true" [style]="{width: '60vw'}" (onHide)="shippingMethodForm.reset()">
  <form [formGroup]="shippingMethodForm">
    <div class="header">
      <h5>Delivery Method Information
        <p-inputSwitch class="header-switch" formControlName="statusId" [disabled]="statusDisabled"
        (onChange)="checkShippingMethodStatus()"></p-inputSwitch>
      </h5>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-6">
          <label>Name <span style="color: red;">*</span></label>
            <input pInputText type="text" formControlName="name" />
            <small *ngIf="invalidData" class="p-invalid">Name already exists.</small>
        </div>
        <div class="p-col-6">
          <label>Finance Account <span style="color: red;">*</span></label>
          <p-treeSelect class="border-bottom-input" [options]="financialAccounts" appendTo="body"
          placeholder="Select Financial Account" formControlName="financialAccountId" display="comma" 
          [metaKeySelection]="false" selectionMode="single"></p-treeSelect>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid" *ngIf="isDisplayParent && !isAddShippingMethod">
        <div class="p-col-6">
          <label>Category</label>
          <p-dropdown [options]="allShippingMethods" formControlName="parentShippingMethodId" optionLabel="name"
             placeholder="Select Method" [ngModelOptions]="{standalone: true}" appendTo="body" [disabled]="isDisplayParent && !isAddShippingMethod">
          </p-dropdown>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid" *ngIf="isAddShippingMethod">
        <div class="p-col-12">
          <label>Category</label>
          <p-dropdown [options]="allShippingMethodDropdown" formControlName="parentShippingMethodId" optionLabel="name"
             placeholder="Select Method" [ngModelOptions]="{standalone: true}" appendTo="body">
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="displayShippingMethodAdd=false" label="Cancel"
      class="p-button-secondary"></button>
    <button type="button" pButton [disabled]="!shippingMethodForm.valid" (click)="saveShippingMethod(shippingMethodForm.value)" label="Save"></button>
  </p-footer>
</p-dialog>


<!-- Ups Service Selection Dialog-->
<p-dialog header="Select Service" [(visible)]="displayUpsServiceSelectionDialog" [style]="{width: '80vw'}" [blockScroll]="true" class="no-padding-top" [closable]="true" (onHide)="oncloseUpsServiceSelectionDialog()">
      <div class="card" style="padding-bottom: 10px;">
          <div class="p-grid">
              <div class="p-col-12">
                  <p-table [value]="upsServices" [(selection)]="selectedUpsServices" [scrollable]="true" scrollHeight="400px">
                      <ng-template pTemplate="header">
                          <tr>
                              <th style="width: 4rem">
                                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                              </th>
                              <th>Service Name</th>
                          </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-service let-rowIndex="rowIndex">
                          <tr class="p-selectable-row">
                              <td>
                                  <p-tableCheckbox [value]="service"></p-tableCheckbox>
                              </td>
                              <td>{{service?.serviceName}}</td>
                          </tr>
                      </ng-template>
                  </p-table>
              </div>
          </div>
      </div>
      <ng-template pTemplate="footer">
          <p-button (click)="oncloseUpsServiceSelectionDialog()" label="Cancel" styleClass="p-button-secondary"></p-button>
          <p-button (click)="addUpsService()" label="Save" [disabled]="selectedUpsServices?.length == 0"></p-button>
      </ng-template>
</p-dialog>


